import { AuditSummaryFlag } from "views/applications-id/components/ApplicantsTable/components/AuditSummaryFlag";
import { Applicant } from "types/application";
import { EmptyCellIcon } from "./EmptyCellIcon";

export const DataWithAuditFlag = ({
  hasData,
  dataValue,
  hasAuditFlagEnabled,
  auditSummaryFlags,
  fallbackValue
}: {
  hasData: boolean;
  dataValue: React.ReactNode;
  hasAuditFlagEnabled: boolean;
  auditSummaryFlags?: Applicant["audit_summary_flags"];
  fallbackValue?: React.ReactNode;
}): JSX.Element => {
  if (hasData && dataValue !== "-") return dataValue as JSX.Element;

  if (hasAuditFlagEnabled && auditSummaryFlags)
    return <AuditSummaryFlag audit_summary_flags={auditSummaryFlags} />;

  if (fallbackValue) return <span>{fallbackValue}</span>;

  return <EmptyCellIcon />;
};
